{
    "data": {
        "SiteContextData": {
            "type": "object",
            "properties": {
                "brand": {
                    "type": "object",
                    "properties": {
                        "voice": {
                            "type": "string"
                        },
                        "colors": {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "fonts": {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "layoutStyle": {
                            "type": ["string", "null"]
                        },
                        "mediaStyle": {
                            "type": ["string", "null"]
                        }
                    },
                    "required": ["voice", "colors", "fonts"],
                    "additionalProperties": false
                },
                "businessContext": {
                    "type": "object",
                    "properties": {
                        "siteName": {
                            "type": "string"
                        },
                        "siteDescription": {
                            "type": "string"
                        },
                        "industry": {
                            "type": ["string", "null"]
                        },
                        "services": {
                            "type": ["array", "null"],
                            "items": {
                                "type": "string"
                            }
                        },
                        "location": {
                            "type": ["string", "null"]
                        },
                        "keywords": {
                            "type": ["array", "null"],
                            "items": {
                                "type": "string"
                            }
                        }
                    },
                    "required": ["siteName", "siteDescription"],
                    "additionalProperties": false
                }
            },
            "required": ["brand", "businessContext"],
            "isTopLevelDataNode": true,
            "additionalProperties": false
        }
    }
}
